import {
    IconAvtoDorogi,
    IconGazoprovod,
    IconInzhPodgotovka,
    IconKust,
    IconNeftesbor,
    IconPloshadka,
    IconVL,
    IconVodovod,
} from 'components/icons';
import { ActKc2StatusEnum, SkzsActKc2StatusEnum } from 'gql/graphql';
import type { BimActKc2OtherStatusEnum, CostGroupEnum, BimActKc2StatusEnum } from 'gql/graphql';
import { ConstructionTypeCodeEnum } from 'types/constructionTypeCode';
import type { BadgePropStatus } from 'uikit';

export const enum TabsIds {
    COMMON,
    PRICE,
    ACCUMULATION_SHEET,
}

export const enum TabsIdsDistribution {
    COMMON = 'COMMON',
    LIMITS = 'LIMITS',
    FORMULA = 'FORMULA',
    DISTRIBUTION = 'DISTRIBUTION',
    TREATY = 'TREATY',
}

export const tabItemsDistribution = [
    { label: 'Общие данные', id: TabsIdsDistribution.COMMON },
    { label: 'Лимиты по сезонам', id: TabsIdsDistribution.LIMITS },
    { label: 'Лимиты по Договору', id: TabsIdsDistribution.TREATY },
    { label: 'Распределение лимитов', id: TabsIdsDistribution.DISTRIBUTION },
];

export const ConstructionTypeIcon: Record<string, typeof IconGazoprovod | null> = {
    [ConstructionTypeCodeEnum.GasPipeline]: IconGazoprovod,
    [ConstructionTypeCodeEnum.Motorway]: IconAvtoDorogi,
    [ConstructionTypeCodeEnum.OilPipeline]: IconNeftesbor,
    [ConstructionTypeCodeEnum.PlantArea]: IconPloshadka,
    [ConstructionTypeCodeEnum.Powerline]: IconVL,
    [ConstructionTypeCodeEnum.SitePreparation]: IconInzhPodgotovka,
    [ConstructionTypeCodeEnum.Unset]: null,
    [ConstructionTypeCodeEnum.WaterPipeline]: IconVodovod,
    [ConstructionTypeCodeEnum.WeltCluster]: IconKust,
};

export const ActKC2StatusLabels: Record<BimActKc2OtherStatusEnum | ActKc2StatusEnum | BimActKc2StatusEnum, string> = {
    [ActKc2StatusEnum.InProgress]: 'В работе',
    [ActKc2StatusEnum.OnCheck]: 'На проверке',
    [ActKc2StatusEnum.Accepted]: 'Согласован',
};

const ActKC2StatusColors: Record<BimActKc2OtherStatusEnum | ActKc2StatusEnum | BimActKc2StatusEnum, string> = {
    [ActKc2StatusEnum.InProgress]: 'normal',
    [ActKc2StatusEnum.OnCheck]: 'progress',
    [ActKc2StatusEnum.Accepted]: 'success',
};

export const getActKC2StatusLabel = (status?: BimActKc2OtherStatusEnum | ActKc2StatusEnum | BimActKc2StatusEnum) =>
    status ? ActKC2StatusLabels[status] : '';

export const getActKC2StatusItem = (id: BimActKc2OtherStatusEnum | ActKc2StatusEnum) => ({
    id,
    label: getActKC2StatusLabel(id),
});

export const getActKC2StatusColor = (status: BimActKc2OtherStatusEnum | ActKc2StatusEnum | BimActKc2StatusEnum) =>
    ActKC2StatusColors[status] as BadgePropStatus & 'progress';

export const ActKC2CostGroup: Record<CostGroupEnum, string> = {
    CMR: 'СМР',
    OTHERS: 'Прочие',
};

export const getSkzsActKc2StatusTitle = (status?: SkzsActKc2StatusEnum | null, isaPlural?: boolean) => {
    if (!status) {
        return '';
    }

    const SkzsActKc2StatusTitle = {
        [SkzsActKc2StatusEnum.New]: isaPlural ? 'Новые' : 'Новый',
        [SkzsActKc2StatusEnum.Updated]: isaPlural ? 'Обновленные' : 'Обновленный',
        [SkzsActKc2StatusEnum.Corrected]: isaPlural ? 'Отредактированные' : 'Отредактированный',
    };

    return SkzsActKc2StatusTitle[status];
};

export type TConstructionTypesIndexes = '-2' | '-3' | '-4' | '-5' | '-6' | '-7' | '-8' | '-9';

export const notFrameLowName = 'расчет по договору';
